const STORAGE_KEY = 'digipalz_region'

export const REGIONS = {
  US: 'us',
  CA: 'ca'
}

export const REGION_LABELS = {
  [REGIONS.US]: 'United States',
  [REGIONS.CA]: 'Canada'
}

export const REGION_DOMAINS = {
  [REGIONS.US]: 'https://digipalz.io',
  [REGIONS.CA]: 'https://digipalz.ca'
}

const PRODUCTION_HOSTNAMES = {
  'digipalz.io': REGIONS.US,
  'www.digipalz.io': REGIONS.US,
  'digipalz.ca': REGIONS.CA,
  'www.digipalz.ca': REGIONS.CA
}

const FIREBASE_TO_CUSTOM_DOMAIN = {
  'digipalz-10512.web.app': REGION_DOMAINS[REGIONS.US],
  'digipalz-10512.firebaseapp.com': REGION_DOMAINS[REGIONS.US],
  'digipalz-canada.web.app': REGION_DOMAINS[REGIONS.CA],
  'digipalz-canada.firebaseapp.com': REGION_DOMAINS[REGIONS.CA]
}

const GEO_COUNTRY_CACHE_KEY = 'digipalz_geo_country'

export function redirectFirebaseHostToCustomDomain() {
  if (typeof window === 'undefined') return
  const hostname = window.location.hostname
  const customOrigin = FIREBASE_TO_CUSTOM_DOMAIN[hostname]
  if (customOrigin) {
    window.location.replace(customOrigin + window.location.pathname + window.location.search)
  }
}

function getCurrentProductionRegion() {
  if (typeof window === 'undefined') return null
  return PRODUCTION_HOSTNAMES[window.location.hostname] || null
}

function getCountryFromIP() {
  try {
    return sessionStorage.getItem(GEO_COUNTRY_CACHE_KEY)
  } catch {
    return null
  }
}

function setCountryCache(countryCode) {
  try {
    if (countryCode) sessionStorage.setItem(GEO_COUNTRY_CACHE_KEY, countryCode)
  } catch {}
}

export async function redirectByGeoIfNeeded() {
  if (typeof window === 'undefined') return false
  const currentRegion = getCurrentProductionRegion()
  if (!currentRegion) return false

  let countryCode = getCountryFromIP()
  if (!countryCode) {
    try {
      const res = await fetch('https://ipapi.co/json/', {
        method: 'GET',
        headers: { Accept: 'application/json' }
      })
      if (!res.ok) return false
      const data = await res.json()
      if (data.error) return false
      countryCode = (data.country_code || '').toUpperCase()
      setCountryCache(countryCode)
    } catch {
      return false
    }
  }

  const isCanadaIP = countryCode === 'CA'
  const targetRegion = isCanadaIP ? REGIONS.CA : REGIONS.US
  if (currentRegion === targetRegion) return false

  const targetOrigin = REGION_DOMAINS[targetRegion]
  if (!targetOrigin) return false
  window.location.replace(targetOrigin + window.location.pathname + window.location.search)
  return true
}

function isProductionDomain() {
  if (typeof window === 'undefined') return false
  return window.location.hostname in PRODUCTION_HOSTNAMES
}

export function getRegionFromDomain() {
  if (typeof window === 'undefined') return null
  return PRODUCTION_HOSTNAMES[window.location.hostname] || null
}

export function getStoredRegion() {
  const domainRegion = getRegionFromDomain()
  if (domainRegion) return domainRegion

  try {
    return localStorage.getItem(STORAGE_KEY) || REGIONS.US
  } catch {
    return REGIONS.US
  }
}

export function setRegion(region) {
  try {
    localStorage.setItem(STORAGE_KEY, region)
  } catch {
    // localStorage unavailable
  }
}

export function setRegionAndReload(region) {
  setRegion(region)

  if (isProductionDomain()) {
    const targetDomain = REGION_DOMAINS[region]
    if (targetDomain && !window.location.origin.startsWith(targetDomain)) {
      window.location.href = targetDomain + window.location.pathname
      return
    }
  }

  window.location.reload()
}

export function mapCountryToRegion(country) {
  if (country === 'Canada') return REGIONS.CA
  return REGIONS.US
}

export function mapRegionToCountry(region) {
  if (region === REGIONS.CA) return 'Canada'
  return 'United States'
}
